
import React from 'react'

import './styles.scss'
import { lang } from 'utils/helpers'

const SelectionBanner = props => {
  const { pageCount, totalCount, isAllSelected, toggleSelectedAll } = props

  return (
    <div className='search-results-selection-banner'>
      <p
        className='search-results-selection-banner__text'
        dangerouslySetInnerHTML={{
          __html: !isAllSelected ? (
            lang('dashboard_you-selected-count-conversations-page', { count: pageCount })
          ) : (
            lang('dashboard_you-selected-all-count-conversations', { count: totalCount })
          )
        }}
      />
      <button
        className='search-results-selection-banner__btn'
        onClick={() => typeof toggleSelectedAll === 'function' ? toggleSelectedAll(!!isAllSelected) : null}
      >
        {!isAllSelected ? (
          lang('dashboard_select-all-count-conversations', { count: totalCount })
        ) : (
          lang('dashboard_clear-selection')
        )}
      </button>
    </div>
  )
}

export default SelectionBanner
